import React from "react";
import { Scatter } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  Tooltip,
  Title,
  TimeScale,
} from "chart.js";
import "chartjs-adapter-date-fns";

ChartJS.register(LinearScale, PointElement, Tooltip, Title, TimeScale);

export default function ScatterChart({ data }) {
  const chartData = {
    datasets: [
      {
        label: "Bids Over Time",
        data: data.map(item => ({
          x: new Date(item.date),
          y: item.count,
        })),
        backgroundColor: "rgba(153, 102, 255, 0.6)",
      },
    ],
  };

  const options = {
    scales: {
      x: {
        type: "time",
        time: {
          unit: "day",
        },
        title: {
          display: true,
          text: "Date",
        },
      },
      y: {
        title: {
          display: true,
          text: "Bids",
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="chartCard">
      <h3>Bids Over Time</h3>
      <Scatter data={chartData} options={options} />
    </div>
  );
}
